import React, { FC, useState } from "react";
import { getDaysRemaining } from "helpers/common/roleHelper";
import BetaPlanBannerCard from "./component/BetaPlanBannerCard";
import BetaPlanDaysRemainNotSubscribedPlanBanner from "./component/BetaPlanDaysRemainNotSubscribedPlanBanner";
import SubscriptedPlanBannerCard from "./component/SubscriptedPlanBannerCard";
import atsLogo from "assets/svg/ats-logo.svg";
import sapiensLogo from "assets/svg/sapiens-logo.png";

type PropsType = {
  companySubscriptionDetailsList: any[];
};

const PRODUCT_TAB_ICON: Record<string, string> = {
  HIRE: atsLogo,
  SAPIENS: sapiensLogo,
};

const SubscriptionBanner: FC<{ currentPlan: any }> = ({ currentPlan }) => {
  const productGuid =
    currentPlan?.subscriptionPricingPlan?.subscriptionPlanProduct?.productType
      ?.guid;

  if (!currentPlan?.havePlan || currentPlan?.status === "I") {
    return (
      <BetaPlanDaysRemainNotSubscribedPlanBanner isDisplayNotPlan={true} />
    );
  } else if (
    currentPlan?.subscriptionPricingPlan?.subscriptionPlanProduct
      ?.subscriptionPlan?.subscriptionPlanDisplayName === "Beta"
  ) {
    return getDaysRemaining(currentPlan?.endDate) > 7 ? (
      <BetaPlanBannerCard currentPlan={currentPlan} />
    ) : (
      <BetaPlanDaysRemainNotSubscribedPlanBanner
        daysRemaining={getDaysRemaining(currentPlan?.endDate)}
        isDisplayNotPlan={false}
        productGuid={productGuid}
      />
    );
  } else {
    return <SubscriptedPlanBannerCard currentPlan={currentPlan} />;
  }
};

const SubscriptionDetailCard: FC<PropsType> = ({
  companySubscriptionDetailsList,
}) => {
  const plans =
    companySubscriptionDetailsList && companySubscriptionDetailsList.length > 0
      ? companySubscriptionDetailsList
      : [{ havePlan: false }];

  const [activeIndex, setActiveIndex] = useState(0);

  // Single product (the common case): keep the original, tab-free layout.
  if (plans.length <= 1) {
    return <SubscriptionBanner currentPlan={plans[0]} />;
  }

  const safeIndex = activeIndex < plans.length ? activeIndex : 0;
  const activePlan = plans[safeIndex];
  const activeProductType =
    activePlan?.subscriptionPricingPlan?.subscriptionPlanProduct?.productType;

  return (
    <div className="ni-dash-sub-tabs">
      <div
        className="ni-dash-sub-tablist"
        role="tablist"
        aria-label="Subscribed products"
      >
        {plans.map((plan: any, index: number) => {
          const productType =
            plan?.subscriptionPricingPlan?.subscriptionPlanProduct
              ?.productType;
          const productKey = (productType?.name ?? "").toUpperCase();
          const label =
            productType?.displayName ?? productType?.name ?? `Product ${index + 1}`;
          const isActive = index === safeIndex;

          const icon = PRODUCT_TAB_ICON[productKey];

          return (
            <button
              key={productType?.guid ?? index}
              type="button"
              role="tab"
              aria-selected={isActive}
              data-product={productKey}
              className={`ni-dash-sub-tab ${isActive ? "is-active" : ""}`}
              onClick={() => setActiveIndex(index)}
            >
              {icon && (
                <img src={icon} alt="" className="ni-dash-sub-tab-icon" />
              )}
              <span>{label}</span>
              {plan?.isExpired && (
                <span className="ni-dash-sub-tab-flag" aria-hidden="true" />
              )}
            </button>
          );
        })}
      </div>
      <SubscriptionBanner
        key={activeProductType?.guid ?? safeIndex}
        currentPlan={activePlan}
      />
    </div>
  );
};

export default SubscriptionDetailCard;
